// Fallback keeps `npm run serve` working for local dev. When the
// webpack dev server runs, window.APP_CONFIG is undefined, so we
// read Vue CLI's .env.development at build time via process.env.
const fallback = {
  BASE_URL: process.env.VUE_APP_BASE_URL || '',
};

export const config = window.APP_CONFIG || fallback;
